$(document).on 'click', '[data-toggle="mobile-collapse"]', ->
  target = $(this).data('target') || $(this).attr('href')
  $(target).collapse('toggle')

$('.mobile-collapse').collapse()
